import React, { useEffect, useLayoutEffect, useReducer } from "react";
import styles from "../not-found/styles.module.scss";
import { Button, Typography } from "@material-ui/core";
import i18next from "i18next";
import { memoryHistory } from "../../../../index";
import { ROUTE_MESSENGER } from "../../../../constants/routes";
import { useLocation, useNavigate } from "react-router-dom";
import { ReducersType } from "../../../../store";
import { useSelector, useStore } from "react-redux";

export function ActiveTab() {
  const multiSessionOpen = useSelector<ReducersType, boolean>((state) => state.messenger.multiSession);
  const navigator = useNavigate();

  useEffect(() => {
    if (!multiSessionOpen) navigator(ROUTE_MESSENGER);
  }, []);

  const onClickReload = () => window.location.reload();

  return (
    <div className={`d-flex flex-wrap flex-column justify-content-center align-items-center text-light ${styles.error_container}`}>
      <Typography variant={"h4"}>{i18next.t("multi_tab.title")}</Typography>
      <p>{i18next.t("multi_tab.desc")}</p>
      <Button variant={"contained"} color={"primary"} onClick={onClickReload}>
        {i18next.t("multi_tab.cta")}
      </Button>
    </div>
  );
}
